function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardNumberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.998,
    height: 17.999,
    viewBox: "0 0 23.998 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1003",
    transform: "translate(-296.001 -179.001)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 7",
    d: "M1251 9265h-22a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1zm-20-16a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1z",
    transform: "translate(-932 -9068)",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 478",
    width: 6,
    height: 4,
    rx: 1,
    transform: "translate(310 182)",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 479",
    transform: "translate(313 189)",
    style: {
      fill: "#707070"
    },
    d: "M0 0h3v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 480",
    transform: "translate(309 189)",
    style: {
      fill: "#707070"
    },
    d: "M0 0h3v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 481",
    transform: "translate(305 189)",
    style: {
      fill: "#707070"
    },
    d: "M0 0h3v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 484",
    transform: "translate(305 192)",
    style: {
      fill: "#707070"
    },
    d: "M0 0h7v1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 482",
    transform: "translate(301 189)",
    style: {
      fill: "#707070"
    },
    d: "M0 0h3v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 483",
    transform: "translate(301 192)",
    style: {
      fill: "#707070"
    },
    d: "M0 0h3v1H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardNumberIcon);
export default __webpack_public_path__ + "static/media/card-number-icon.1d303009.svg";
export { ForwardRef as ReactComponent };